import React, { useState } from 'react'

interface ExpandableCellProps {
  text: string
  className?: string
  maxLength?: number
}

export const ExpandableCell: React.FC<ExpandableCellProps> = ({
  text,
  className = '',
  maxLength = 150,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const shouldTruncate = text.length > maxLength

  const displayText =
    isExpanded || !shouldTruncate ? text : `${text.substring(0, maxLength)}...`

  return (
    <div>
      <div className={`break-words ${className}`}>{displayText}</div>
      {shouldTruncate && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-1 text-sm text-blue-600 hover:text-blue-800 underline focus:outline-none"
        >
          {isExpanded ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  )
}
